// Keep public trip links on the website and on other people's profiles.
export function openOwnProfileBooking({ profileUserId, viewerUserId, tripId }) {
  if (
    !profileUserId ||
    !viewerUserId ||
    String(profileUserId) !== String(viewerUserId) ||
    !tripId ||
    typeof window === "undefined" ||
    !window.isInApp ||
    !window.ReactNativeWebView?.postMessage
  ) {
    return false;
  }

  window.ReactNativeWebView.postMessage(
    JSON.stringify({ type: "navigateToTripDetails", tripId })
  );
  return true;
}
